<template>
  <div class="item-row-wrap" :class="{ 'item-row-primary-wrap': level === 1 }">
    <template v-if="!(rowValue.children && rowValue.children.length)">
      <Row class="item-row" :class="{ 'item-row-children': level > 1 }" :gutter="20">
        <!-- key -->
        <i-col :span="fieldColSpan" class="item-col icon-arrow-wrap">
          <span :class="{ empty: level > 2 }" :style="{ marginRight: `${rowPaddingLeft}px` }"></span>
          <!-- <i-input
            v-model="rowValue.name"
            :class="{ 'error-input': rowValue.errorNameMsg }"
            :disabled="disabled"
            @on-blur="inputValueChange(rowValue, 'key')"
          /> -->
          <span>{{ rowValue.name }}</span>
        </i-col>
        <!-- value -->
        <i-col v-if="isHeaderField" :span="fieldColSpan" class="item-col" />
        <i-col v-else :span="fieldColSpan" class="item-col">
          <i-switch v-if="rowValue.type === 'bool'" v-model="rowValue.default" size="small" />
          <i-input
            v-else-if="rowValue.control === 'text' && rowValue.type === 'int'"
            v-model="rowValue.default"
            type="number"
            :disabled="disabled"
            :class="{ 'error-input': rowValue.errorValueMsg }"
            @on-blur="inputValueChange(rowValue, 'value')"
          />
          <i-input
            v-if="rowValue.control === 'textarea' && rowValue.type !== 'int'"
            v-model="rowValue.default"
            type="textarea"
            :rows="1"
            :disabled="disabled"
            :class="{ 'error-input': rowValue.errorValueMsg }"
            @on-blur="inputValueChange(rowValue, 'value')"
          />
          <i-input
            v-else
            v-model="rowValue.default"
            :placeholder="String(rowValue.default)"
            :disabled="disabled"
            :class="{ 'error-input': rowValue.errorValueMsg }"
            @on-blur="inputValueChange(rowValue, 'value')"
          />
        </i-col>

        <!-- oprations -->
        <template v-if="isHeaderField">
          <i-col v-if="operable" :span="operableColSpan" class="item-col item-col-oprations" />
        </template>
        <template v-else>
          <i-col v-if="operable" :span="operableColSpan" class="item-col item-col-oprations">
            <Icon
              type="ios-add-circle-outline"
              :size="20"
              class="operation-btn operation-btn-add"
              @click.stop="addItem(rowValue)"
            />
            <Icon
              type="ios-remove-circle-outline"
              :size="20"
              class="operation-btn operation-btn-remove"
              @click.stop="removeItem(rowValue)"
            />
          </i-col>
        </template>
      </Row>

      <!-- headers -->
      <template v-if="isHeaderField">
        <Row
          ref="keyValueEditorRef"
          class="item-row item-row-headers"
          :class="{ 'item-row-children': level > 1 }"
          :gutter="20"
        >
          <i-col :span="24" class="item-col item-col-divider">
            <Divider class="divider-line" />
          </i-col>
          <i-col :span="24" class="item-col item-col-headers">
            <!-- if you change the class name, please modify the class name of 'getElementsByClassName' in validateKeyValueEditors function -->
            <KeyValueEditor class="keyValueEditorRef" v-model="rowValue.default" :submitDataType="rowValue.type" />
          </i-col>
        </Row>
      </template>
    </template>

    <!-- has children -->
    <template v-else-if="rowValue.children && rowValue.children.length">
      <Row class="item-row item-row-parent" :gutter="20">
        <!-- key -->
        <i-col :span="fieldColSpan" class="item-col icon-arrow-wrap">
          <span :style="{ marginRight: `${rowPaddingLeft}px` }"></span>
          <Icon
            :type="rowValue.showChildren ? 'ios-arrow-down' : 'ios-arrow-forward'"
            class="icon-arrow"
            @click.native="isShowChildren(!rowValue.showChildren)"
          />
          <span>{{ rowValue.name }}</span>
          <!-- <i-input
            v-model="rowValue.name"
            :disabled="disabled"
            :class="{ 'error-input': rowValue.errorNameMsg }"
            @on-blur="inputValueChange(rowValue, 'key')"
          /> -->
        </i-col>
        <!-- value -->
        <i-col :span="fieldColSpan" class="item-col" />
        <!-- oprations -->
        <i-col v-if="operable" :span="operableColSpan" class="item-col item-col-oprations">
          <Icon
            type="ios-add-circle-outline"
            :size="20"
            class="operation-btn operation-btn-add"
            @click.stop="addItem(rowValue)"
          />
          <Icon
            type="ios-remove-circle-outline"
            :size="20"
            class="operation-btn operation-btn-remove"
            @click.stop="removeItem(rowValue)"
          />
        </i-col>
      </Row>
      <div v-show="!!rowValue.showChildren">
        <TableTreeItem
          ref="tableTreeRef"
          v-for="(child, cindex) in rowValue.children"
          :key="cindex"
          :index="cindex"
          :item="child"
          :level="childrenLevel"
          class="item-row-children-wrap"
          :operable="operable"
          :fieldColSpan="fieldColSpan"
          :operableColSpan="operableColSpan"
          @addItem="addItem"
          @removeItem="removeItem"
        />
      </div>
    </template>
  </div>
</template>

<script>
import KeyValueEditor from '@/components/KeyValueEditor.vue'

export default {
  name: 'TableTreeItem',
  props: {
    index: { type: Number, default: null },
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    operable: { type: Boolean, default: true },
    fieldColSpan: { type: String, default: '' },
    operableColSpan: { type: String, default: '' },
  },

  components: { KeyValueEditor },

  data() {
    return {
      rowValue: {},
    }
  },

  computed: {
    childrenLevel() {
      return this.level + 1
    },
    rowPaddingLeft() {
      return this.level > 1 ? this.level * 10 : 0
    },
    listObjectType() {
      return ['list_object', 'object']
    },
    isHeaderField() {
      return (
        this.rowValue.name === 'headers' &&
        this.rowValue.control === 'list' &&
        this.listObjectType.includes(this.rowValue.type)
      )
    },
  },

  watch: {
    item: {
      immediate: true,
      handler(newV) {
        this.$nextTick(() => {
          this.rowValue = newV
        })
      },
      deep: true,
    },
    rowValue: {
      immediate: true,
      handler(newV) {
        this.$emit('update:value', newV)
      },
      deep: true,
    },
  },

  methods: {
    addItem(row) {
      this.$emit('addItem', row)
    },

    removeItem(row) {
      this.$emit('removeItem', row)
    },

    isShowChildren(val) {
      this.$set(this.rowValue, 'showChildren', val)
    },

    validateName(row) {
      if (row.name === '') {
        this.$set(this.rowValue, 'errorNameMsg', 'error')
      } else {
        this.$set(this.rowValue, 'errorNameMsg', '')
      }
      return Promise.resolve(this.rowValue.errorNameMsg)
    },

    validateValue(row) {
      if (!row.optional && row.default === '') {
        this.$set(this.rowValue, 'errorValueMsg', 'error')
      } else {
        this.$set(this.rowValue, 'errorValueMsg', '')
      }
      return Promise.resolve(this.rowValue.errorValueMsg)
    },

    async validateKeyValueEditors() {
      const validators = []
      /** Use 'getElementsByClassName' instead of 'refs'.
       * because the nesting, using 'ref' also requrieds recursive lookup,
       * but using 'getElementsByClassName' can get directly
       */
      const refs = document.getElementsByClassName('keyValueEditorRef')
      Array.from(refs).forEach((item) => {
        const { __vue__ } = item
        const { validateKeyValueEditor } = __vue__
        if (validateKeyValueEditor) {
          validators.push(validateKeyValueEditor())
        }
      })

      if (!validators.length) {
        return Promise.resolve(true)
      }

      const validRes = await Promise.allSettled(validators)
      const valid = validRes.every((item) => item?.value)

      if (valid) {
        return Promise.resolve(valid)
      }
      return Promise.reject(this.$t('common.fillContent'))
    },

    async inputValueChange(row, type) {
      if (type === 'key') {
        await this.validateName(row)
      } else if (type === 'value') {
        await this.validateValue(row)
      }
    },

    async transferKeyValueEditorData() {
      const trans = []
      const refs = document.getElementsByClassName('keyValueEditorRef')
      Array.from(refs).forEach((item) => {
        const { __vue__ } = item
        const { transferData } = __vue__
        if (transferData) {
          trans.push(transferData())
        }
      })

      await Promise.allSettled(trans)
      return Promise.resolve()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.item-row-wrap {
  width: 100%;
  border-top: 1px solid;
  border-left: 1px solid;
  border-right: 1px solid;
  border-color: var(--color-header-bg);

  &:last-child {
    border-bottom: 1px solid var(--color-header-bg);
  }
}
.item-row-primary-wrap {
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
}
.item-row-children-wrap {
  border-left: none;
  border-right: none;
  &:last-child {
    border-bottom: none;
  }
}

.item-row {
  padding: 0 10px;
  &:hover {
    background-color: var(--color-header-bg);
  }
  .item-col {
    @include display-flex(center, center, nowrap);
    height: 48px;
  }
}

// headers
.item-row-headers {
  padding-left: 28px;
  .item-col {
    min-height: 48px;
    height: auto;
  }

  .item-col-divider {
    min-height: fit-content;
  }
  .divider-line {
    margin-top: 0;
    margin-bottom: 10px;
  }
}

.item-col.icon-arrow-wrap,
.item-col.item-col-oprations {
  @include display-flex(flex-start, center, nowrap);
}
.icon-arrow {
  margin-right: 4px;
}

.empty {
  display: inline-block;
  width: 10px;
}

.operation-btn {
  margin-right: 10px;
  cursor: pointer;
  &-add {
    color: $--primary-color;
  }
  &-remove {
    color: $--danger-color;
  }
}

::v-deep {
  .error-input > input,
  .error-input > textarea {
    border-color: $--danger-color;
  }
}
</style>
